import React, { useEffect, useState } from "react";
import "../../Css/BookingAppointmnet.css";
import Header from "../NavBar/Header";
import Footer from "../Footer";

import { message, Empty, Spin } from "antd";
import axios from "axios";
import { get, post } from "../../services/userAuthAPI";
import { getProfile } from "../../services/localStorageServices";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const BookingAppointmnet = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [services, setServices] = useState([]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [slots, setSlots] = useState([]);
  const [selectedMain, setSelectedMain] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [availableDays, setAvailableDays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { profile } = getProfile();
  const navigate = useNavigate();

  const access_token = "45|vs0kaCjy7fyFOKF8UkSj16WCfAvN1CS5hFewCL36a29314f9"; // replace with getToken()

  // ✅ Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const res = await get("maincategories?page=1&limit=50&all=1");
        setServices(res.data.data || res.data);
      } catch (err) {
        message.error("Failed to load services");
      } finally {
        setLoading(false);
      }
    };

    const dboucne = setTimeout(() => {
      // ✅ Fetch slots for selected service
      fetchServices();
    }, 300);

    return () => clearTimeout(dboucne);
  }, []);

  const handleBookAppointment = () => {
    if (!selectedMain || !selectedService || !selectedDay || !selectedSlot) {
      message.error("Please select all fields before booking.");
      return;
    }

    message.success(
      `✅ Appointment booked!\nGender: ${selectedMain}\nService: ${
        services.find((s) => s.id === Number(selectedService))?.name
      }\nDay: ${selectedDay}\nTime: ${selectedSlot}`
    );
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("user_id", profile.id);
      formData.append("service_id[]", selectedService.id);
      
      // Get the next occurrence of the selected day
      const selectedDayNum = moment().day(selectedDay).day();
      const today = moment();
      let appointmentDate = moment();
      
      // Find the next occurrence of the selected day
      if (today.day() >= selectedDayNum) {
        appointmentDate = appointmentDate.add(1, 'week');
      }
      appointmentDate = appointmentDate.day(selectedDayNum);
      
      formData.append(
        "appointment_date",
        appointmentDate.format("YYYY-MM-DD")
      );
      formData.append("appointment_time", selectedSlot);
      formData.append("appointment_status", "Success");
      formData.append("subtotal", selectedService.price);
      formData.append("total", selectedService.price);
      formData.append("remaining", 0);
      formData.append("tax", 0);

      const header = {
        Authorization: `Bearer ${access_token}`,
      };
      const resp = await post("/appointments", formData, header);

      if (resp) {
        message.success("Appointment created successfully!");
        navigate("/profile-details?active=appointment");
      }
    } catch (error) {
      message.error("Failed to add service! Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Spin spinning={loading}>
        <div
          className="booking-form-container"
          style={{
            padding: window.innerWidth < 768 ? "20px" : "40px",
            width: "90%",
            maxWidth: "800px",
            margin: window.innerWidth < 768 ? "100px auto 40px" : "150px auto 80px",
            boxShadow: "0px 0px 6px 0px #0458385C",
            borderRadius: "10px",
          }}
        >
          <h2
            style={{
              fontFamily: "Marcellus",
              textAlign: "center",
              marginBottom: "30px",
              color: "#025739",
            }}
          >
            Book Your Appointment
          </h2>

          {/* =================== Main Category ================ */}
          <div style={{ marginBottom: "30px" }}>
            <label style={{ fontWeight: "bold", display: "block" }}>
              Looking For
            </label>
            <div 
              style={{ 
                display: "flex", 
                gap: "10px", 
                marginTop: "10px",
                flexWrap: "wrap",
                justifyContent: window.innerWidth < 768 ? "center" : "flex-start"
              }}
            >
              {services.map((val) => (
                <button
                  key={val.name}
                  onClick={() => setSelectedMain(val)}
                  style={{
                    padding: window.innerWidth < 768 ? "8px 16px" : "10px 20px",
                    borderRadius: "8px",
                    border:
                      selectedMain?.id === val?.id
                        ? "2px solid #025739"
                        : "1px solid #ccc",
                    backgroundColor:
                      selectedMain?.id === val?.id ? "#025739" : "#fff",
                    color: selectedMain?.id === val?.id ? "#fff" : "#333",
                    fontSize: window.innerWidth < 768 ? "14px" : "16px",
                    marginBottom: window.innerWidth < 768 ? "8px" : "0",
                    flex: window.innerWidth < 768 ? "0 0 calc(50% - 10px)" : "auto",
                  }}
                >
                  {val?.name}
                </button>
              ))}
            </div>
          </div>

          {/* =================== Category ================ */}

          {selectedMain?.sub_categories?.length === 0 || !selectedMain ? (
            <Empty description="Select service from tab you looking for" />
          ) : (
            <div style={{ marginBottom: "30px" }}>
              <label style={{ fontWeight: "bold", display: "block" }}>
                Select Category
              </label>
              <select
                value={selectedCategory?.name || ""}
                onChange={(e) =>
                  setSelectedCategory(
                    selectedMain.sub_categories.find(
                      (cat) => cat.name === e.target.value
                    )
                  )
                }
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  marginTop: "10px",
                }}
              >
                <option value="">-- Select Category --</option>
                {selectedMain?.sub_categories?.map((service) => (
                  <option key={service.id} value={service.name}>
                    {service.name}
                  </option>
                ))}
              </select>

              {/* =================== Services ================ */}
              {selectedCategory?.services?.length === 0 || !selectedCategory ? (
                <Empty description="Select Avalable Category from list" />
              ) : (
                <div style={{ marginBottom: "30px", marginTop: "20px" }}>
                  <label style={{ fontWeight: "bold", display: "block" }}>
                    Select Service
                  </label>
                  <select
                    value={selectedService?.name || ""}
                    onChange={(e) =>
                      setSelectedService(
                        selectedCategory?.services?.find(
                          (service) => service.name === e.target.value
                        )
                      )
                    }
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      marginTop: "10px",
                    }}
                  >
                    <option value="">-- Select Available Service --</option>
                    {selectedCategory?.services?.map((service) => (
                      <option key={service.id} value={service.name}>
                        {service.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {selectedService &&
                selectedService.service_times &&
                selectedService.service_times.length > 0 && (
                  <>
                    <div style={{ marginBottom: "30px" }}>
                      <label style={{ fontWeight: "bold", display: "block" }}>
                        Available Days
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexWrap: "wrap",
                          marginTop: "10px",
                          justifyContent: window.innerWidth < 768 ? "center" : "flex-start"
                        }}
                      >
                        {Array.from(
                          new Set(
                            selectedService.service_times.map(
                              (time) => time.day
                            )
                          )
                        ).map((day) => (
                          <button
                            key={day}
                            onClick={() => setSelectedDay(day)}
                            style={{
                              padding: window.innerWidth < 768 ? "8px 16px" : "10px 20px",
                              borderRadius: "8px",
                              border:
                                selectedDay === day
                                  ? "2px solid #025739"
                                  : "1px solid #ccc",
                              backgroundColor:
                                selectedDay === day ? "#025739" : "#fff",
                              color: selectedDay === day ? "#fff" : "#333",
                              fontSize: window.innerWidth < 768 ? "14px" : "16px",
                              marginBottom: window.innerWidth < 768 ? "8px" : "0",
                              flex: window.innerWidth < 768 ? "0 0 calc(50% - 10px)" : "auto",
                            }}
                          >
                            {day}
                          </button>
                        ))}
                      </div>
                    </div>

                    {selectedDay && (
                      <div style={{ marginBottom: "30px" }}>
                        <label style={{ fontWeight: "bold", display: "block" }}>
                          Available Slots
                        </label>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap",
                            marginTop: "10px",
                          }}
                        >
                          {selectedService.service_times
                            .filter((time) => time.day === selectedDay)
                            .map((timeSlot) => (
                              <button
                                key={timeSlot.id}
                                onClick={() => setSelectedSlot(timeSlot.slot)}
                                style={{
                                  padding: "10px 20px",
                                  borderRadius: "8px",
                                  border:
                                    selectedSlot === timeSlot.slot
                                      ? "2px solid #025739"
                                      : "1px solid #ccc",
                                  backgroundColor:
                                    selectedSlot === timeSlot.slot
                                      ? "#025739"
                                      : "#fff",
                                  color:
                                    selectedSlot === timeSlot.slot
                                      ? "#fff"
                                      : "#333",
                                }}
                              >
                                {timeSlot.slot}
                              </button>
                            ))}
                        </div>
                      </div>
                    )}
                  </>
                )}

              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  style={{
                    padding: "12px 30px",
                    fontSize: "18px",
                    borderRadius: "8px",
                    backgroundColor: "#025739",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={onFinish}
                >
                  Book Appointment
                </button>
              </div>
            </div>
          )}
        </div>
      </Spin>
      <Footer />
    </>
  );
};

export default BookingAppointmnet;
